import { listGeneratedRecordStages, type GeneratedRecordStage } from '@/entities/GeneratedRecord';

export type LoadLineageStages = (prefix: string) => Promise<GeneratedRecordStage[]>;

/**
 * The filter panel remounts on every opening. Without a cache, a stage already in the filter would
 * show "Selecione a etapa" until the list came back. A known lineage answers at once and refreshes
 * in the background; only a lineage never loaded can fail. The cache lives with the page, so a
 * branch change, which leaves the page, drops it.
 */
export function useLineageStages(): LoadLineageStages {
  const cache = new Map<string, GeneratedRecordStage[]>();

  return async (prefix) => {
    const request = listGeneratedRecordStages(prefix).then((stages) => {
      cache.set(prefix, stages);
      return stages;
    });
    const cached = cache.get(prefix);

    if (cached === undefined) return request;

    request.catch(() => undefined);
    return cached;
  };
}
